<template>
  <div class="crystal-card dev-card relative" v-motion-slide-visible-bottom>
    <!-- Dev ribbon -->
    <div class="dev-ribbon">DEV</div>

    <!-- Subtle glow -->
    <div class="absolute -top-10 -right-10 w-32 h-32 rounded-full pointer-events-none"
         style="background: radial-gradient(circle, rgba(232, 139, 199, 0.08), transparent 70%);"></div>

    <div class="flex items-start gap-3 mb-4">
      <!-- Dev avatar (always lotus) -->
      <div class="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center border border-pink-400/30 bg-gradient-to-br from-pink-500/20 to-purple-500/20">
        <AvatarIcon avatar-id="lotus" size="sm" />
      </div>

      <div class="flex-1 min-w-0 space-y-0.5">
        <h3 class="text-base font-semibold text-nirvana-white/90">
          Handlers ทีมพัฒนา — Kanosume 'Kurumina' Umiki
        </h3>
        <a 
          v-if="wish.twitter"
          :href="`https://twitter.com/${cleanTwitterHandle(wish.twitter)}`"
          target="_blank"
          rel="noopener noreferrer"
          class="text-xs text-nirvana-lotus/50 hover:text-nirvana-lotus transition-colors inline-flex items-center gap-0.5"
        >
          @{{ cleanTwitterHandle(wish.twitter) }}
        </a>
      </div>
      
      <!-- Open Button -->
      <button
        @click="openWish"
        class="flex-shrink-0 p-2 text-nirvana-silver/20 hover:text-nirvana-lotus transition-colors rounded-lg hover:bg-nirvana-lotus/5 ml-auto"
        title="Open this wish"
      >
        <ArrowUpRightSquare class="w-5 h-5" />
      </button>
    </div>

    <p class="text-nirvana-silver/70 mb-4 whitespace-pre-wrap leading-relaxed text-[15px]">{{ wish.message }}</p>

    <img
      v-if="wish.fanart"
      :src="wish.fanart"
      :alt="`แฟนอาร์ตโดยทีมพัฒนา`"
      class="w-full max-h-72 object-contain rounded-lg mb-4 ring-1 ring-nirvana-lotus/10"
      loading="lazy"
    />

    <div class="ornate-divider mb-3"></div>
    <div class="flex justify-between items-center">
      <span class="text-xs text-nirvana-silver/25">
        {{ formatDate(wish.createdAt) }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { format } from 'date-fns'
import { ArrowUpRightSquare } from 'lucide-vue-next'
import AvatarIcon from '@/components/AvatarIcon.vue'
import { cleanTwitterHandle } from '@/utils/formatters'

const props = defineProps({
  wish: {
    type: Object,
    required: true
  }
})

function formatDate(date) {
  return format(new Date(date), 'MMM d, yyyy')
}

function openWish() {
  window.open(`${window.location.origin}/wish/${props.wish.number}`, '_blank')
}
</script>

<style scoped>
.dev-card {
  border-color: rgba(232, 139, 199, 0.15) !important;
}

.dev-card:hover {
  border-color: rgba(232, 139, 199, 0.3) !important;
  box-shadow:
    0 8px 40px rgba(232, 139, 199, 0.08),
    0 0 20px rgba(123, 47, 242, 0.06) !important;
}

.dev-ribbon {
  position: absolute;
  top: 12px;
  right: -32px;
  padding: 3px 0;
  width: 100px;
  text-align: center;
  font-weight: 700;
  font-size: 0.6rem;
  letter-spacing: 0.15em;
  color: #050510;
  background: linear-gradient(135deg, #e88bc7, #7b2ff2);
  transform: rotate(45deg);
  box-shadow: 0 2px 10px rgba(232, 139, 199, 0.3);
  z-index: 10;
}
</style>
